export default __webpack_public_path__ + "static/media/arrow-left.744f7a2c.svg";